export default "__VITE_ASSET__725df7fc__"